module.exports = __webpack_public_path__ + "img/mobile_title.6fc5836e.png";